import { TableCell } from '@mui/material';
import PropTypes from 'prop-types';
import { cellColors } from '../../shared/constants/commonCellColors';
import CellViewer from '../Cells/CellViewer';
import stylizeCell from '../../shared/functions/cellStyling';
import sxPropType from '../../shared/propTypes/sxPropType';

const CELL_STYLE_KEYS = {
  ...Object.keys(cellColors).reduce((acc, key) => ({ ...acc, [key]: key }), {}),
  input: 'input',
};

export default function FilteredTableDataCell({ data, index, dropdownTable, type, cellSx, className }) {
  const stylizedCellKey = stylizeCell(data[index], CELL_STYLE_KEYS, index);
  const resolvedCellSx = stylizedCellKey && stylizedCellKey !== 'normal' ? cellColors[stylizedCellKey] : null;

  return (
    <TableCell className={className} sx={[{ maxWidth: 1000 }, resolvedCellSx, cellSx]} align="left">
      <CellViewer cells={data} index={index} dropdownTable={dropdownTable} type={type} />
    </TableCell>
  );
}

FilteredTableDataCell.propTypes = {
  className: PropTypes.string,
  data: PropTypes.object,
  cellSx: sxPropType,
  dropdownTable: PropTypes.object,
  index: PropTypes.string,
  type: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
